export const colorConstant = {
    blueTheme: '#01579b',
    errorRed: '#ff0000',
    linkColor:'#3949ab',
    errorToaster:'#bd362f',
    successToaster:'#51a351',
    infoToaster:'#2f96b4',
}